module.exports = __webpack_public_path__ + "static/img/cyfw_banner_1.6ba2428.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cyfw_banner_1.png
// module id = E2Y4
// module chunks = 1